import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import React from "react";
import { useState } from "react";
import palette from "../../theme/palette";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  AddHomeWorkOutlined,
  MedicalServicesOutlined,
  TtyOutlined,
} from "@mui/icons-material";
import allDoctors from "../../assets/all-doctors.png";
import availableNow from "../../assets/available-now.png";
import allSpecialist from "../../assets/all-specialities.png";

const ActionButton = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  height: "100px",
  width: "100px",
  borderRadius: "5px",
  paddingBottom: "5px",
  border: "1px solid #BFBFBF",
  "&:hover": {
    boxShadow: "0px 0px 5px 3px #BFBFBF",
    cursor: "pointer",
  },
});

const StyledTextField = styled(TextField)({
  ".MuiInput-underline": {
    marginTop: 3,
  },
});
const StepOne = ({ setDoctorFilterObj, specialities }) => {
  const [doctorNameKeyword, setDoctorNameKeyword] = useState("");
  const [selectedSpecialization, setSelectedSpecialization] = useState(
    "All Specialities"
  );
  const [date, setDate] = useState(new Date());

  const specializationOptions = React.useMemo(() => {
    const unique = [...new Set(specialities)].filter(
      (speciality) => speciality !== null && speciality !== undefined
    );
    return ["All Specialities", ...unique];
  }, [specialities]);

  const onClickAllSpecialist = () => {
    setDoctorFilterObj({
      doctorName: "",
      specialization: "",
      date: "",
    });
  };

  const onClickAllDoctors = () => {
    setDoctorFilterObj({
      doctorName: "",
      specialization: "",
      date: "",
    });
  };

  const onClickNowAvailable = () => {
    setDoctorFilterObj({
      doctorName: "",
      specialization: "",
      date: new Date(),
      strictlyTodayCheck: new Date(),
    });
  };

  return (
    <Grid item xs={12} sm lg mt={2.3}>
      <Box
        sx={{
          borderRadius: 3,
          border: "1px solid #BFBFBF",
          px: 2,
          pb: 3,
          pt: 1,
          "&:hover": {
            boxShadow: "0px 0px 2px 1px #BFBFBF",
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "1.5rem",
            fontWeight: "bold",
            mb: 1.5,
          }}
        >
          Search doctor
        </Typography>
        <Box>
          <TextField
            label={"Doctor name"}
            fullWidth
            size="small"
            value={doctorNameKeyword}
            onChange={(e) => {
              setDoctorNameKeyword(e.target.value);
            }}
          />
        </Box>

        <Box mt={2}>
          <FormControl
            fullWidth
            sx={{
              "& .MuiInput-underline:before": {
                borderBottom: "none",
              },
              mb: 0.5,
              border: `1px solid transparent`,
            }}
          >
            <Autocomplete
              disablePortal
              options={specializationOptions}
              value={selectedSpecialization}
              onChange={(event, newValue) => {
                setSelectedSpecialization(newValue || "All Specialities");
              }}
              disableClearable
              size="small"
              sx={{
                "& .MuiAutocomplete-input": {
                  padding: "8px 8px !important",
                },
                "& .MuiOutlinedInput-root": {
                  padding: "1px 8px !important",
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="All Specialities"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: palette.light.grey[400],
                      },
                      "&:hover fieldset": {
                        borderColor: palette.light.grey[400],
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: palette.light.primary.main,
                      },
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Box>

        <Box mt={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={date}
              onChange={(newValue) => {
                setDate(newValue);
              }}
              className="date-picker"
              sx={{ flexGrow: 1, mr: 2, width: { xs: "100%" } }}
              renderInput={(params) => (
                <StyledTextField
                  label="Select date"
                  fullWidth
                  size="small"
                  sx={{
                    mt: 0,
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              setDoctorFilterObj({
                doctorName: doctorNameKeyword,
                specialization: selectedSpecialization,
                date: date,
              });
            }}
          >
            Search
          </Button>
        </Box>
      </Box>
      <Box mt={2} display={"flex"} justifyContent={"space-between"}>
        <ActionButton onClick={onClickNowAvailable}>
          <Box flexGrow={1} display={"flex"} alignItems={"center"}>
            <img src={availableNow} alt="available now" width={"50px"} />
          </Box>
          <Typography
            fontSize={"0.75rem"}
            textAlign={"center"}
            fontWeight={"bold"}
          >
            Now Available
          </Typography>
        </ActionButton>
        <ActionButton onClick={onClickAllSpecialist}>
          <Box flexGrow={1} display={"flex"} alignItems={"center"}>
            <img src={allSpecialist} alt="all specialities" width={"50px"} />
          </Box>
          <Typography
            fontSize={"0.8rem"}
            textAlign={"center"}
            fontWeight={"bold"}
          >
            All Specialist
          </Typography>
        </ActionButton>
        <ActionButton onClick={onClickAllDoctors}>
          <Box flexGrow={1} display={"flex"} alignItems={"center"}>
            <img src={allDoctors} alt="all doctors" width={"50px"} />
          </Box>
          <Typography
            fontSize={"0.8rem"}
            textAlign={"center"}
            fontWeight={"bold"}
          >
            All Doctors
          </Typography>
        </ActionButton>
      </Box>
    </Grid>
  );
};

export default StepOne;
